'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weekBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/weekBefore.js
// module id = 749
// module chunks = 0